import a from './axios'
import config from './../config'
const token = localStorage.getItem('token')
a.defaults.headers.common = { Authorization: `Bearer ${token}` }
const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
}

const prefixEndpoint = config.apiBaseUrl

export default {
  prepareExportData(payload) {
    return a.post(prefixEndpoint + 'report/export', payload, headers)
  },
  getReportStockBalancesDate(payload) {
    return a.post(prefixEndpoint + 'report/balance', payload, headers)
  },
  exportReportStockBalancesDate(payload) {
    return a.post(prefixEndpoint + 'report/balance/pdf', payload, {
      headers: headers,
      responseType: 'blob'
    }).then(res => {
      return res
    })
  },
  getReportStockBalancesRange(payload) {
    return a.post(prefixEndpoint + 'report/balance_range', payload, headers)
  },
  exportReportStockBalancesRange(payload) {
    return a.post(prefixEndpoint + 'report/balance_range/pdf', payload, {
      headers: headers,
      responseType: 'blob'
    }).then(res => {
      return res
    })
  }
}
